import { AxiosInstance } from 'axios';
import { TGetAuthTokenResponse, ILoginBody } from 'types/login';
import { IRegisterBody, TRegisterResponse } from 'types/register';

export const oneClubApi = (axios: AxiosInstance, apiDomain: string) => ({
  /**
   * Get token
   */
  getAuthToken: (data: ILoginBody): TGetAuthTokenResponse => {
    return axios.post(`${apiDomain}/members/signinforthirdparty`, data);
  },

  /**
   * Register teacher account
   */
  register(payload: IRegisterBody): TRegisterResponse {
    return axios.post(`${apiDomain}/members/signup`, payload);
  },
});
